import { HolidayService } from '@service/holiday/holiday.service';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { GlobalService } from '@service/global/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import ValidationEngine from 'devextreme/ui/validation_engine';
@Component({
  selector: 'app-holiday-event-reason',
  templateUrl: './holiday-event-reason.component.html',
  styleUrls: ['./holiday-event-reason.component.css'],
})
export class HolidayEventReasonComponent implements OnInit {
  @Input() isPopupVisible: boolean = false;
  @Input() mode: string = 'add';
  @Input() holidayData?: any;

  @Output() isPopupVisibleChange = new EventEmitter<boolean>();
  @Output() onSave = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();

  eventName: string = '';

  constructor(
    public globalService: GlobalService,
    private route: ActivatedRoute,
    public router: Router,
    private readonly holidayService: HolidayService,
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.mode === 'edit' && this.holidayData) {
      this.eventName = this.holidayData.name;
    } else if (this.mode === 'add') {
      this.eventName = '';
    }
  }

  closePopup(): void {
    this.eventName = '';
    this.isPopupVisible = false;
    this.isPopupVisibleChange.emit(this.isPopupVisible);
  }

  saveEvent(): void {
    const { isValid } = ValidationEngine.validateGroup('validationGrp');
    if (!isValid) {
      return;
    }

    if (this.mode === 'edit') {
      const payload = { name: this.eventName };
      this.holidayService
        .updateHolidayEventById(this.holidayData.id, payload)
        .subscribe(
          (res) => {
            if (res.status == 'ok') {
              this.onSave.emit(res);
              this.isPopupVisible = false;
              this.isPopupVisibleChange.emit(this.isPopupVisible);
            }
          },
          (err) => {
            console.log(err);
          },
        );
    } else {
      const payload = {
        list: [
          {
            name: this.eventName,
          },
        ],
      };

      this.holidayService.createHolidayEvent(payload).subscribe(
        (res) => {
          if (res.status == 'ok') {
            this.onSave.emit(res);
            this.isPopupVisible = false;
            this.isPopupVisibleChange.emit(this.isPopupVisible);
          }
        },
        (err) => {
          console.log(err);
        },
      );
    }
  }

  deleteEvent(): void {
    if (this.holidayData) {
      this.onDelete.emit(this.holidayData);
      this.closePopup();
    }
  }
}
